import React, { Fragment } from 'react';
import { SortableContainer, arrayMove } from 'react-sortable-hoc';
import $ from 'jquery';
import throttle from 'lodash/throttle';
import { SortablePageListItem } from './PageListItem';
import { SortableFolderListItem } from './FolderListItem';
import { SortableSuggestionListItem } from './SuggestionListItem';
import { SortableExternalResourceListItem } from './ExternalResourceListItem';
import { SortableQuestionListItem } from './QuestionListItem';
import { SortableDocumentListItem } from './DocumentListItem';
import {
    isPage,
    isSuggestion,
    isExternal,
    isDocument,
    isFolder,
    isQuestion,
} from '../../utilities/categoryUtilities';
import { CATEGORY_ORDER_BY_DEFAULT } from '../../utilities/CONSTANTS';
import { getApiTeamCategoryFolderUrl } from '../../utilities/urlHelper';
import { addErrorMessage } from '../../utilities/notificationUtilities';

const SortablePinnedList = SortableContainer((props) => {
    const { pinnedItems, moveMode, isAuthorized } = props;
    const pinnedListItems = pinnedItems.map((item, i) => {
        if (isPage(item)) {
            return (
                <SortablePageListItem
                    key={item.id + item.type}
                    index={i}
                    page={item}
                    disabled={!isAuthorized}
                    isDraggable={isAuthorized}
                    moveMode={moveMode}
                    checkItem={props.checkItem}
                />
            );
        } if (isFolder(item)) {
            return (
                <SortableFolderListItem
                    key={item.id + item.type}
                    index={i}
                    folder={item}
                    disabled={!isAuthorized}
                    isDraggable={isAuthorized}
                    isAuthorized={isAuthorized}
                    moveMode={moveMode}
                    checkItem={props.checkItem}
                    inSubcategory={false}
                />
            );
        } if (isSuggestion(item)) {
            return (
                <SortableSuggestionListItem
                    key={item.id + item.type}
                    index={i}
                    suggestion={item}
                    disabled={!isAuthorized}
                    isDraggable={isAuthorized}
                    moveMode={moveMode}
                    checkItem={props.checkItem}
                />
            );
        } if (isExternal(item)) {
            return (
                <SortableExternalResourceListItem
                    key={item.id + item.type}
                    index={i}
                    externalResource={item}
                    disabled={!isAuthorized}
                    isDraggable={isAuthorized}
                    isAuthorized={isAuthorized}
                    moveMode={moveMode}
                    checkItem={props.checkItem}
                />
            );
        } if (isDocument(item)) {
            return (
                <SortableDocumentListItem
                    key={item.id + item.type}
                    index={i}
                    tettraDocument={item}
                    disabled={!isAuthorized}
                    isDraggable={isAuthorized}
                    isAuthorized={isAuthorized}
                    moveMode={moveMode}
                    checkItem={props.checkItem}
                />
            );
        } if (isQuestion(item) && window.loggedIn) {
            return (
                <SortableQuestionListItem
                    key={item.id + item.type}
                    index={i}
                    question={item}
                    disabled={!isAuthorized}
                    isDraggable={isAuthorized}
                    isAuthorized={isAuthorized}
                    moveMode={moveMode}
                    checkItem={props.checkItem}
                />
            );
        }
    });
    const className = pinnedListItems.length > 0 ? 'pinned-list-items' : '';

    return (
        <tbody className={className}>
            {pinnedListItems}
        </tbody>
    );
});

const SortableUnpinnedList = SortableContainer((props) => {
    const {
        unPinnedItems, moveMode, hasPinnedItems, subcategory, isAuthorized,
    } = props;
    const usesCustomOrdering = subcategory ? subcategory.order_type === CATEGORY_ORDER_BY_DEFAULT.CUSTOM : window.categoryOrder === CATEGORY_ORDER_BY_DEFAULT.CUSTOM;
    const draggable = isAuthorized && usesCustomOrdering;

    const unPinnedListItems = unPinnedItems.map((item, i) => {
        if (isPage(item)) {
            return (
                <SortablePageListItem
                    key={item.id + item.type}
                    index={i}
                    page={item}
                    disabled={!isAuthorized}
                    isDraggable={draggable}
                    moveMode={moveMode}
                    checkItem={props.checkItem}
                />
            );
        } if (isFolder(item)) {
            return (
                <SortableFolderListItem
                    key={item.id + item.type}
                    index={i}
                    folder={item}
                    disabled={!isAuthorized}
                    isDraggable={draggable}
                    isAuthorized={isAuthorized}
                    moveMode={moveMode}
                    checkItem={props.checkItem}
                />
            );
        } if (isSuggestion(item)) {
            return (
                <SortableSuggestionListItem
                    key={item.id + item.type}
                    index={i}
                    suggestion={item}
                    disabled={!isAuthorized}
                    isDraggable={draggable}
                    isAuthorized={isAuthorized}
                    moveMode={moveMode}
                    checkItem={props.checkItem}
                />
            );
        } if (isExternal(item)) {
            return (
                <SortableExternalResourceListItem
                    key={item.id + item.type}
                    index={i}
                    externalResource={item}
                    disabled={!isAuthorized}
                    isDraggable={draggable}
                    isAuthorized={isAuthorized}
                    moveMode={moveMode}
                    checkItem={props.checkItem}
                />
            );
        } if (isDocument(item)) {
            return (
                <SortableDocumentListItem
                    key={item.id + item.type}
                    index={i}
                    tettraDocument={item}
                    disabled={!isAuthorized}
                    isDraggable={draggable}
                    isAuthorized={isAuthorized}
                    moveMode={moveMode}
                    checkItem={props.checkItem}
                />
            );
        } if (isQuestion(item) && window.loggedIn) {
            return (
                <SortableQuestionListItem
                    key={item.id + item.type}
                    index={i}
                    question={item}
                    disabled={!isAuthorized}
                    isDraggable={draggable}
                    isAuthorized={isAuthorized}
                    moveMode={moveMode}
                    checkItem={props.checkItem}
                />
            );
        }
    });

    const className = hasPinnedItems ? 'unpinned-list-items' : 'pinned-list-items';

    return (
        <tbody className={className}>
            {unPinnedListItems}
        </tbody>
    );
});

const throttledPutPinnableOrder = throttle((pinnableOrder, url) => $.ajax({
    url,
    type: 'PUT',
    data: { pinnableOrder: JSON.stringify(pinnableOrder) },
}).fail((error) => {
    addErrorMessage('Error ordering items, please refresh page and try again.');
}), 2000);

class CategoryPinnableList extends React.Component {

    constructor(props) {
        super(props);
        this.state = this.getState(props);
    }

    getState = (props) => {
        const { isAuthorized, categoryItems } = props;
        const pinnedItems = categoryItems.filter(item => !!item.is_pinned);
        const unPinnedItems = categoryItems.filter(item => !item.is_pinned);
        return { isAuthorized, pinnedItems, unPinnedItems };
    };

    onPinnedItemsEnd = ({ oldIndex, newIndex }) => {
        const { subcategory } = this.props;
        const pinnedItems = arrayMove(this.state.pinnedItems, oldIndex, newIndex);
        pinnedItems.forEach((item, i) => { item.item_rank = i; }); // reset rank for sorting
        this.setState({ pinnedItems });

        const pinnableOrder = pinnedItems.map(({ id, type }) => ({ id, type }));
        const url = subcategory ? getApiTeamCategoryFolderUrl(pinnedItems[0].category_id, pinnedItems[0].folder_id) : window.pinnableOrderUrl;
        throttledPutPinnableOrder(pinnableOrder, url);
    };

    onUnpinnedItemsSortEnd = ({ oldIndex, newIndex }) => {
        const { subcategory } = this.props;
        const unPinnedItems = arrayMove(this.state.unPinnedItems, oldIndex, newIndex);
        unPinnedItems.forEach((item, i) => { item.item_rank = i; }); // reset rank for sorting
        this.setState({ unPinnedItems });

        const pinnableOrder = unPinnedItems.map(({ id, type }) => ({ id, type }));
        const url = subcategory ? getApiTeamCategoryFolderUrl(unPinnedItems[0].category_id, unPinnedItems[0].folder_id) : window.pinnableOrderUrl;
        throttledPutPinnableOrder(pinnableOrder, url);
    };

    componentDidUpdate(prevProps) {
        if ((prevProps.selectedTab !== this.props.selectedTab) || (prevProps.sortOrder !== this.props.sortOrder) || (prevProps.categoryItems.length !== this.props.categoryItems.length)) {
            const { categoryItems } = this.props;
            const pinnedItems = categoryItems.filter(item => !!item.is_pinned);
            const unPinnedItems = categoryItems.filter(item => !item.is_pinned);
            return this.setState({ pinnedItems, unPinnedItems });
        }
    }

    render() {
        const { isAuthorized, pinnedItems, unPinnedItems } = this.state;
        const { folderItemsMap, moveMode } = this.props;
        return (
            <Fragment>
                <SortablePinnedList
                    pinnedItems={pinnedItems}
                    folderItemsMap={folderItemsMap}
                    isAuthorized={isAuthorized}
                    helperClass="is-dragging"
                    onSortEnd={this.onPinnedItemsEnd}
                    useDragHandle
                    moveMode={moveMode}
                    checkItem={this.props.checkItem}
                />
                <SortableUnpinnedList
                    {...this.props}
                    unPinnedItems={unPinnedItems}
                    folderItemsMap={folderItemsMap}
                    isAuthorized={isAuthorized}
                    helperClass="is-dragging"
                    onSortEnd={this.onUnpinnedItemsSortEnd}
                    useDragHandle
                    moveMode={moveMode}
                    checkItem={this.props.checkItem}
                    hasPinnedItems={pinnedItems.length > 0}
                />

                {pinnedItems.length === 0 && unPinnedItems.length === 0
                    && (
                        <tbody>
                            <tr>
                                <td>
                                    <span className="block italic gray p2">
                                    The possibilities are endless...
                                    </span>
                                </td>
                            </tr>
                        </tbody>
                    )}

            </Fragment>
        );
    }
}

export default CategoryPinnableList;
